var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.inputLabel && !_vm.hiddenLabel
      ? _c("label", [
          _vm._v("\n    " + _vm._s(_vm.inputLabel) + "\n    "),
          _vm.isMandatory
            ? _c("span", { staticClass: "color-red" }, [_vm._v("* ")])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "dropdown" }, [
        _vm.valueType === "string"
          ? _c("div", [
              _vm.selectedItem.length === 0
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputValue,
                        expression: "inputValue",
                      },
                    ],
                    ref: "dropdowninput",
                    staticClass: "dropdown-input",
                    class: _vm.errorIndicatorHighlight,
                    style: {
                      height:
                        _vm.customHeight !== "none"
                          ? _vm.customHeight + "px"
                          : "calc(1.5em + 0.75rem + 2px)",
                    },
                    attrs: {
                      type: "text",
                      placeholder: _vm.placeholderValue,
                      autocomplete: "my-field-name",
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.inputValue = $event.target.value
                      },
                    },
                  })
                : _c("input", {
                    staticClass: "dropdown-selected",
                    class: _vm.errorIndicatorHighlight,
                    style: {
                      height:
                        _vm.customHeight !== "none"
                          ? _vm.customHeight + "px"
                          : "calc(1.5em + 0.75rem + 2px)",
                    },
                    attrs: { type: "text" },
                    domProps: { value: _vm.selectedItem },
                    on: { click: _vm.resetSelection },
                  }),
              _vm._v(" "),
              _vm.inputValue && !_vm.selectedItem
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValue,
                          expression: "inputValue",
                        },
                      ],
                      staticClass: "dropdown-list",
                      style: { "max-height": _vm.dropdownMaxHeight },
                    },
                    _vm._l(_vm.defaultItemList, function (item) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.itemVisible(item),
                              expression: "itemVisible(item)",
                            },
                          ],
                          key: item,
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.selectItem(item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(item) + "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm.valueType === "object"
          ? _c("div", [
              _vm.selectedItem.length === 0
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputValueObj,
                        expression: "inputValueObj",
                      },
                    ],
                    ref: "dropdowninput",
                    staticClass:
                      "dropdown-input form-control inputAccordionForm",
                    class: _vm.errorIndicatorHighlight,
                    style: {
                      height:
                        _vm.customHeight !== "none"
                          ? _vm.customHeight + "px"
                          : "calc(1.5em + 0.75rem + 2px)",
                    },
                    attrs: {
                      type: "text",
                      placeholder: _vm.placeholderValue,
                      autocomplete: "my-field-name",
                    },
                    domProps: { value: _vm.inputValueObj },
                    on: {
                      blur: function ($event) {
                        return _vm.sendInputValueObjAsInputValue()
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.inputValueObj = $event.target.value
                      },
                    },
                  })
                : _c("input", {
                    staticClass:
                      "dropdown-selected form-control inputAccordionForm",
                    class: _vm.errorIndicatorHighlight,
                    style: {
                      height:
                        _vm.customHeight !== "none"
                          ? _vm.customHeight + "px"
                          : "calc(1.5em + 0.75rem + 2px)",
                    },
                    attrs: { type: "text" },
                    domProps: { value: _vm.inputValueObj },
                    on: { click: _vm.resetSelection },
                  }),
              _vm._v(" "),
              _vm.inputValueObj && !_vm.selectedItem
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValueObj,
                          expression: "inputValueObj",
                        },
                      ],
                      staticClass: "dropdown-list",
                      style: { "max-height": _vm.dropdownMaxHeight },
                    },
                    _vm._l(_vm.defaultItemList, function (item) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.itemVisible(item),
                              expression: "itemVisible(item)",
                            },
                          ],
                          key: item[_vm.objectKey],
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.selectItem(item)
                            },
                          },
                        },
                        [
                          _c("div", [
                            _c("label", [_vm._v(_vm._s(item[_vm.valueKey]))]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("label", [_vm._v(_vm._s(item[_vm.subTextKey]))]),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.mandatoryErrorIndicator
        ? _c("div", { staticStyle: { color: "red" } }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("errors.is_mandatory", {
                    mandatoryValue: _vm.inputLabel,
                  })
                ) +
                "\n    "
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }